import React, { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from './login/dispatch';
import ClipLoader from "react-spinners/ClipLoader";
import { fetchDataFailure } from './login/action';

function Login() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false); // Add state for "Remember me"
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const { data, isLoading, error } = useSelector(state => state.loginReducer);

  useEffect(() => {
    // Retrieve saved credentials from localStorage if "Remember me" was checked
    const savedUserName = localStorage.getItem('userName');
    const savedPassword = localStorage.getItem('password');
    const savedRememberMe = localStorage.getItem('rememberMe') === 'true';

    if (savedRememberMe && savedUserName && savedPassword) {
      setUserName(savedUserName);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, [dispatch]);

  const validateForm = () => {
    const newErrors = {};
    if (!userName) newErrors.userName = 'User Name is required';
    if (!password) newErrors.password = 'Password is required';
    else if (password.length < 6) newErrors.password = 'Password must be at least 6 characters';
    return newErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      setErrors({});
      console.log('Login attempted with:', { userName, password });
      
      if (rememberMe) {
        // Save credentials to localStorage if "Remember me" is checked
        localStorage.setItem('userName', userName);
        localStorage.setItem('password', password);
        localStorage.setItem('rememberMe', rememberMe);
      } else {
        // Clear stored credentials if "Remember me" is unchecked
        localStorage.removeItem('userName');
        localStorage.removeItem('password');
        localStorage.removeItem('rememberMe');
      }

      dispatch(fetchDataFailure(''));
      dispatch(fetchData(userName, password, navigate));
    }
  };

  return (
    <div className="login-wrapper">
      <div>
        <img src={require('../assets/loginBG.jpg')} style={{ minHeight: '100%', width: '100%' }} />
      </div>
      <div className="login-form-container">
        <img src={require('../assets/logo.png')} style={{ backgroundColor: 'transparent', marginLeft: 'auto', marginRight: 'auto', display: 'block', width: '50%' }} />
        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>User Name</Form.Label>
            <Form.Control
              className="form-control-login"
              type="text"
              placeholder="User Name"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              isInvalid={!!errors.userName}
            />
            <Form.Control.Feedback type="invalid">
              {errors.userName}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              className="form-control-login"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              isInvalid={!!errors.password}
            />
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="flexCheckChecked"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="flexCheckChecked">
              Remember me
            </label>
          </div>

          <div style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em', color: 'var(--bs-form-invalid-color)' }}>
            {error ? error : null}
          </div>

          <Button variant="primary" type="submit" className="login-button">
            Login
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default Login;
